import { ADMIN_ROLES } from '@/auth/roles';
import { RequireRole } from '@/auth/RequireRole';
import type { RouteObject } from 'react-router-dom';

/**
 * Settings area. OWNED BY `m4m5-money` (M4); see docs/BUILD-ORCHESTRATION.md.
 *
 * Add screens as children below. router.tsx already includes these routes, so a new
 * screen inside this area never needs a change outside this folder. Pages load lazily.
 */
export const settingsRoutes: RouteObject[] = [
  {
    path: 'settings',
    handle: { crumb: 'Settings' },
    // Owner and admin only: a trainer never sees this area (CLAUDE.md "Roles").
    element: <RequireRole roles={ADMIN_ROLES} />,
    children: [
      { index: true, lazy: async () => ({ Component: (await import('./SettingsPage')).SettingsPage }) },
    ],
  },
];
